import type { TelemetryModule } from "../di/define-module.js";
import type { TelemetryClient } from "../core/client.js";
import { installVue2Telemetry } from "./vue2.js";
import type { Vue2Constructor } from "./vue2.js";

/** Vue 2 plugin — pass module from `createTelemetry` → `init.module` */
export function createVue2TelemetryPlugin(module: TelemetryModule) {
  return {
    install(Vue: Vue2Constructor) {
      const client = module.getClient();
      if (client) installVue2Telemetry({ client, Vue, runtime: "client" });
    },
  };
}

export function injectTelemetry(
  inject: (key: string | symbol) => TelemetryClient,
  key = "telemetry.client",
): TelemetryClient {
  return inject(key);
}

export interface Vue2TelemetryBindings {
  createPlugin: () => ReturnType<typeof createVue2TelemetryPlugin>;
  inject: typeof injectTelemetry;
}

export function attachVue2Bindings<T extends TelemetryModule>(
  module: T,
): T & Vue2TelemetryBindings {
  return {
    ...module,
    createPlugin: () => createVue2TelemetryPlugin(module),
    inject: injectTelemetry,
  };
}
